import { useCallback, useState } from 'react';
import { RetrieveS3URLResponse } from '../../../../api/document/files/api-services/model';
import { FileUploadState } from '../../../../models/File';
import * as QUERIES from '../../../../api/candidate/result/@coordinator/queries-services/queries';
import { ResultReleasesSchema } from '../../../../models/@org-admin/ResultReleasesShema';

export const useDownload = (resultListPageContent: ResultReleasesSchema[]) => {
  const [openDialog, setOpenDialog] = useState(false);
  const [fileDownloadStatus, setFileDownloadStatus] = useState<FileUploadState>(
    FileUploadState.IDLE
  );
  const [fileUUID, setFileUUID] = useState('');

  /** Query to post Bulk Download Data
   * */
  const { mutate: bulkDownloadMutate } = QUERIES.usePostBulkDownloadCoordinatorResultRelease(
    (response) => {
      setFileUUID(response.uuid);
    },
    (error) => null
  );

  /** to define bulk download
   * */
  const onBulkDownload = useCallback(
    (selectedIndexNo: string[]) => {
      bulkDownloadMutate(selectedIndexNo);
    },
    [bulkDownloadMutate]
  );

  /** handle download action
   * */
  const downloadTemplate = (downloadResponse: RetrieveS3URLResponse) => {
    setOpenDialog(true);
    if (downloadResponse.fileStatus === FileUploadState.SUCCESS) {
      setFileUUID('');
      setOpenDialog(false);
    }
    setFileDownloadStatus(downloadResponse.fileStatus as FileUploadState);
  };

  /** to handle dialog close action
   * */
  const onDialogClose = () => {
    setOpenDialog(false);
    setFileUUID('');
  };

  return {
    openDialog,
    fileDownloadStatus,
    fileUUID,
    onBulkDownload,
    downloadTemplate,
    onDialogClose,
  };
};
